import React from 'react';
import classnames from 'classnames';
import LoadingIndicator from '../LoadingIndicator';
import PlusIcon from '../Icons/Plus';
import CheckIcon from '../Icons/Check';
import AddIcon from '../Icons/Add';
import { IconSize } from '../Icons/IconWrap';
import UserAvatar from '../User/Avatar';
import s from './SmallGroupCard.scss';
export var SmallGroupCard = function (_a) {
    var _b = _a.mode, mode = _b === void 0 ? 'default' : _b, group = _a.group, className = _a.className;
    var hasThumb = !group.usericonDefault;
    return (React.createElement("div", { className: classnames(s['root'], s["mode-" + mode], className) },
        React.createElement("div", { className: classnames(s['thumb'], !hasThumb && s['empty']) },
            React.createElement("div", { className: s['thumb-content'] }, hasThumb && (React.createElement(UserAvatar, { className: s['group-avatar'], user: group, withLink: false, withTooltip: false }))),
            React.createElement("div", { className: s['overlay'] },
                mode === 'add' && React.createElement(AddIcon, { className: s['icon'] }),
                mode === 'progress' && (React.createElement(LoadingIndicator, { view: "llama", className: s['loader'] })),
                mode === 'default' && (React.createElement(PlusIcon, { className: s['icon'], size: IconSize.SMALL })),
                ['done', 'selected'].includes(mode) && (React.createElement(CheckIcon, { className: s['icon'], size: IconSize.SMALL })))),
        React.createElement("div", { className: s['title'] }, group.username)));
};
SmallGroupCard.displayName = 'SmallGroupCard';
export default SmallGroupCard;
//# sourceMappingURL=SmallGroupCard.js.map